import React from "react"

import BasePermissionGate, { BasePermissionGateProps } from "@/components/PermissionGate/BasePermissionGate"

const IntegrationGroupPermissionGate = (props: Omit<BasePermissionGateProps<"integration">, "feature">) => {
	return (
		<BasePermissionGate
			{...props}
			feature="integration"
		/>
	)
}

export default IntegrationGroupPermissionGate
